import React, { memo } from 'react';
import { useTable, usePagination, useSortBy, Column } from 'react-table';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserSubscription } from '@t/subscriptions';
import { DATE_TIME_FORMAT } from '@config';

import styles from './styles.module.css';

export interface Props {
    userSubscriptions: UserSubscription[];
}

const columns: Column<UserSubscription>[] = [
    {
        Header: 'user subscription Id',
        accessor: (userSubscription: UserSubscription) => userSubscription._id,
    },
    {
        Header: 'user Id',
        accessor: (userSubscription: UserSubscription) =>
            userSubscription.userId,
    },
    {
        Header: 'subscription',
        accessor: (userSubscription: UserSubscription) =>
            userSubscription.subscriptionTitle,
    },
    {
        Header: 'Статус',
        accessor: (userSubscription: UserSubscription) =>
            userSubscription.paymentStatus,
    },
    {
        Header: 'date Started',
        accessor: (userSubscription: UserSubscription) =>
            moment(userSubscription.dateStarted).format(DATE_TIME_FORMAT),
    },
    {
        Header: 'next Payment Date',
        accessor: (userSubscription: UserSubscription) =>
            moment(userSubscription.nextPaymentDate).format(DATE_TIME_FORMAT),
    },
];

export const SubscriptionsListTable: React.FC<Props> = memo(
    ({ userSubscriptions }) => {
        const {
            getTableProps,
            getTableBodyProps,
            headerGroups,
            prepareRow,
            page,
        } = useTable(
            {
                columns,
                data: userSubscriptions || [],
                initialState: {
                    pageIndex: 0,
                    pageSize: 1000,
                },
            },
            useSortBy,
            usePagination
        );
        const history = useHistory();

        return (
            <>
                <table {...getTableProps()} className={styles.table}>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr
                                {...headerGroup.getHeaderGroupProps()}
                                key={Math.random()}
                            >
                                {headerGroup.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps(
                                            column.getSortByToggleProps()
                                        )}
                                        key={Math.random()}
                                    >
                                        {column.render('Header')}
                                        <span className={styles.sorted}>
                                            <FontAwesomeIcon
                                                icon={
                                                    column.isSorted
                                                        ? column.isSortedDesc
                                                            ? 'sort-up'
                                                            : 'sort-down'
                                                        : 'sort'
                                                }
                                            />
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                            prepareRow(row);
                            const onClick = () => {
                                const subscription = row.original;
                                history.push(
                                    `/dashboard/subscriptions/${subscription._id}`
                                );
                            };
                            return (
                                <tr
                                    {...row.getRowProps()}
                                    className={styles.tableRow}
                                    onClick={onClick}
                                    key={Math.random()}
                                >
                                    {row.cells.map((cell) => {
                                        return (
                                            <td
                                                {...cell.getCellProps()}
                                                key={Math.random()}
                                            >
                                                {cell.render('Cell')}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </>
        );
    }
);

export default SubscriptionsListTable;
